import './navbar.scss';
import { useState, useEffect } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, Outlet, useLocation } from 'react-router-dom';
import dashUnclickIcon from '../../images/svg/dashunclickicon.svg';
import callsUnclickIcon from '../../images/svg/callunclickicon.svg';
import callsClickIcon from '../../images/svg/callclickicon.svg';
import dashClickIcon from '../../images/svg/dashclickicon.svg';
import settingsIcon from '../../images/svg/settingsicon.svg';
import logoutIcon from '../../images/svg/logouticon.svg';
import nextgptBlueIcon from '../../images/svg/nextgptblue.svg';
import jacksonimage from '../../images/people/jackson.png';
import ncsLogo from '../../images/svg/ncslogo.svg';
import { Row, Col, Container } from 'react-bootstrap';
import smList from '../../mocks/profiles/smList.json';

function getRandomNineDigitNumber() {
  let min = 100000000;
  let max = 999999999;
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function NavBar() {
  const location = useLocation();
  const randomNumber = getRandomNineDigitNumber();
  const isActive = (pathname) => location.pathname === pathname;
  const [selectedSM] = useState(localStorage.getItem('SM') || 'Jackson Lim');
  const [smImage, setSmImage] = useState(jacksonimage);

  useEffect(() => {
    const selectedSMProfile = smList.profile.find(profile => profile.name === selectedSM);
    if (selectedSMProfile) {
      setSmImage(selectedSMProfile.image);
    }
  }, [selectedSM]);

  // List of valid routes
  const validRoutes = ['/', '/dashboard', '/calls', '/settings'];

  // Check if the current route is valid
  const isRouteValid = validRoutes.includes(location.pathname);

  return (
    <Row className='something'>
      <Navbar className="sidebar no-gutters">
        <Container className='buttonsplit'>
          <Row>
            <span className='subtext'>
              <Navbar.Brand as={Link} to="/dashboard">
                <img src={ncsLogo} alt="" />
                RELATIONSHIP MANAGER<br />COMPLIANCE DEMO
              </Navbar.Brand>
            </span>
            <Row>
              <span className={isActive('/dashboard')||isActive('/') ? 'currentpage' : 'uncurrentpage'}>
                <Nav.Link as={Link} to="/dashboard">
                  <img src={isActive('/dashboard')||isActive('/') ? dashClickIcon : dashUnclickIcon} alt="" /> Dashboard
                </Nav.Link>
              </span>
              <span className={isActive('/calls') ? 'currentpage' : 'uncurrentpage'}>
                <Nav.Link as={Link} to="/calls">
                  <img src={isActive('/calls') ? callsClickIcon : callsUnclickIcon} alt="" />Calls Review
                </Nav.Link>
              </span>
            </Row>
          </Row>
          
          <Row className='settings'>
            <span className={isActive('/settings') ? 'currentpage' : 'uncurrentpage'}>
              <Nav.Link as={Link} to="/settings">
                <img src={isActive('/settings') ? settingsIcon : settingsIcon} alt="Settings" /> Settings
              </Nav.Link>
            </span>
            <span className={isActive('/logout') ? 'currentpage' : 'uncurrentpage'}>
              <Nav.Link as={Link} to="/logout">
                <img src={logoutIcon} alt="Logout" /> Logout
              </Nav.Link>
            </span>
            <div className='nextgpt'> <img src={nextgptBlueIcon} alt="" /> </div>
          </Row>
        </Container>
      </Navbar>
      <Col className='contentwithtitle'>
        <Row className='toprow'>
          <Col>
            {isActive('/') || isActive('/dashboard') ? <header>Dashboard</header> : <div />}
            {isActive('/calls') ? (
              <header>
                <ul className='breadcrumbs1'>
                  <li>
                    <a className='headerReview' href="http://localhost:3000/calls">Calls Review &#62; </a>
                  </li>
                  <li>
                    <a className='headerRMNumber' href="http://localhost:3000/calls">RMC{randomNumber} </a>
                  </li>
                </ul>
              </header>
            ) : <div />}
            {isActive('/settings') ? <header>Settings</header> : <div />}
          </Col>
          {isRouteValid && (
            <Col className='sminfo'>
              <Col className='profilepic'>
                <img src={smImage} alt="Profile" />
              </Col>
              <Col className='smtext'>
                <label className="smName">{selectedSM}</label>
                <label className="sm">Sales Manager</label>
              </Col>
            </Col>
          )}
        </Row>
        <Row>
          <Col className="content">
            <Outlet /> {/* Display route content */}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default NavBar;
